import { render, staticRenderFns } from "./ElementType.vue?vue&type=template&id=7845fdaa&scoped=true&"
import script from "./ElementType.vue?vue&type=script&lang=js&"
export * from "./ElementType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7845fdaa",
  null
  
)

export default component.exports